export default __webpack_public_path__ + "static/media/logo-ico.4854585e.png";